"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentSection = exports.ContentSectionDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_title_1 = require("./content-title");
var use_lang_1 = require("../../hooks/use-lang");
exports.ContentSectionDefaultProps = {
  showDivider: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: ", " ", ";\n\n    ", "\n\n    &:first-child {\n      padding-top: 0;\n    }\n\n    &:last-child {\n      background: none;\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: ", " ", ";\n\n    ", "\n\n    &:first-child {\n      padding-top: 0;\n    }\n\n    &:last-child {\n      background: none;\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(0), function (props) {
    return props.showDivider && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      ", ";\n      padding-bottom: ", ";\n    "], ["\n      ", ";\n      padding-bottom: ", ";\n    "])), theme_1.theme.H_DOT_BG_END(), theme_1.theme.UNIT(4, 2));
  }),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TitleSuffixStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-weight: 400;\n    font-size: 0.95em;\n    padding-left: 2px;\n    color: ", ";\n  "], ["\n    font-weight: 400;\n    font-size: 0.95em;\n    padding-left: 2px;\n    color: ", ";\n  "])), theme_1.theme.COLOR("text-subtle"))
});
var HeadStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    align-items: center;\n    flex-direction: row;\n  "], ["\n    align-items: center;\n    flex-direction: row;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.section(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Head: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), HeadStyles),
  Title: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  TitleSuffix: styled_components_1.default.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TitleSuffixStyles),
  Controls: styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles)
};
var ContentSection = function (props) {
  var className = props.className,
    title = props.title,
    titleSuffix = props.titleSuffix,
    children = props.children,
    controls = props.controls,
    showDivider = props.showDivider;
  var t = (0, use_lang_1.useLang)();
  return react_1.default.createElement(My.Container, {
    showDivider: showDivider,
    className: className
  }, (title || controls) && react_1.default.createElement(My.Head, null, title && react_1.default.createElement(My.Title, null, t(title), titleSuffix && react_1.default.createElement(My.TitleSuffix, null, t(titleSuffix))), controls && react_1.default.createElement(My.Controls, null, controls)), children);
};
exports.ContentSection = ContentSection;
exports.ContentSection.defaultProps = exports.ContentSectionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;